import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchUserAttributes } from 'aws-amplify/auth';

const CuentaActivaContext = createContext({ activo: true, cargando: true });

export const useCuentaActiva = () => useContext(CuentaActivaContext);

const LAMBDA_URL = 'https://s7mffazil1.execute-api.us-east-1.amazonaws.com/produccion/lambda';

export const CuentaActivaProvider = ({ children }) => {
  const [activo, setActivo] = useState(true);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetchUserAttributes()
      .then((attributes) => {
        const sub = attributes.sub;
        return fetch(LAMBDA_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ accion: 'consultar_activo', sub }),
        });
      })
      .then((res) => res.json())
      .then((data) => {
        console.log('Estado cuenta activa:', data);
        // Si la respuesta viene envuelta del Lambda (statusCode, body, headers)
        let resultado = data;
        if (data.body) {
          resultado = typeof data.body === 'string' ? JSON.parse(data.body) : data.body;
        }
        setActivo(resultado.activo !== false);
      })
      .catch((err) => {
        console.error('Error consultando estado activo:', err);
        setActivo(true);
      })
      .finally(() => setCargando(false));
  }, []);

  return (
    <CuentaActivaContext.Provider value={{ activo, cargando }}>
      {children}
    </CuentaActivaContext.Provider>
  );
};

export default CuentaActivaContext;
